// ============================================================================
// todo-client-mod -- Todo 注册器
//
// 1. 通过 DI 获取 IUserCenterSlotsService，注册 "my-todos" slot 到用户中心
//    （用户管理待办事项的地方）
// 2. 注册公开页面路由：
//    - /todo     — 待办事项列表页（给访客浏览）
//    - /todo/:id — 待办事项详情页
// 3. 使用 IFetchService 实现 SSR loader（后端直接调用服务，避免 Worker 死锁）
//
// 关键设计：
// - SSR loader 通过 IFetchService 预取数据
// - 浏览器端：IFetchService → BrowserFetchService → 原生 fetch → /api/todos
// - SSR 端：IFetchService → BackendFetchService → 直接调用 TodoService（无 HTTP 开销，无死锁）
// ============================================================================
import { TodoPanel } from './components/todo-panel.js';
import { TodoListPage } from './pages/todo-list-page.js';
import { TodoDetailPage } from './pages/todo-detail-page.js';
import { TodoIcon } from './components/icons.js';
/**
 * Todo 客户端注册器
 */
export class TodoRegistrar {
    constructor(deps) {
        const { userCenterSlots, pageRouteRegistry, fetchService } = deps;
        this.fetchService = fetchService;
        // 1. 注册 "我的待办" slot 到用户中心（管理后台）
        userCenterSlots.registerSlot({
            id: 'my-todos',
            label: '我的待办',
            icon: TodoIcon,
            component: TodoPanel,
            order: 15,
            modName: 'todo-client',
        });
        // 2. 注册公开 Todo 列表页（带 SSR loader）
        pageRouteRegistry.registerPage({
            path: '/todo',
            component: TodoListPage,
            key: 'todo-list',
            meta: {
                title: '待办事项',
            },
            modName: 'todo-client',
            loader: async (args) => {
                const searchParams = new URLSearchParams();
                // 合并 URL 中的参数（分页等）
                if (args.location.query) {
                    for (const [k, v] of Object.entries(args.location.query)) {
                        if (v != null)
                            searchParams.set(k, String(v));
                    }
                }
                const url = `/api/todos?${searchParams.toString()}`;
                const response = await this.fetchService.fetch(url, {
                    method: 'GET',
                    headers: args.request?.headers,
                });
                return response.json();
            },
        });
        // 3. 注册公开 Todo 详情页（带 SSR loader）
        pageRouteRegistry.registerPage({
            path: '/todo/:id',
            component: TodoDetailPage,
            key: 'todo-detail',
            meta: {
                title: '待办详情',
            },
            modName: 'todo-client',
            loader: async (args) => {
                const id = args.params.id;
                const url = `/api/todos/${id}`;
                const response = await this.fetchService.fetch(url, {
                    method: 'GET',
                    headers: args.request?.headers,
                });
                return response.json();
            },
        });
    }
}
//# sourceMappingURL=todo-registrar.js.map